import moment from 'moment'
import React from 'react'

import resize from '../../utils/resize'
import AlwayzImage from '../../components/molecules/AlwayzImage'
import UserStore from '../../stores/UserStore'

const NovelChapterComponent = ({
  type, // 추후 확장 시 사용 ('main'만 사용중)
  novelData,
  viewLogData,
  chapterInfo,
  chapterCount,
  setModalType,
  setModalProp,
  setOpenModal,
}) => {
  const viewedChapterList = viewLogData?.viewedChapterIdList
  const isViewed = viewedChapterList?.some(
    (viewLog) => viewLog?.chapterId.toString() === chapterInfo?._id.toString()
  )
  const lastRentedAt = viewedChapterList?.find(
    (viewLog) => viewLog.chapterId.toString() === chapterInfo._id.toString()
  )?.rentedAt

  const isViewableChapter =
    isViewed && moment().diff(moment(lastRentedAt), 'days') <= novelData?.rentPeriod

  const promotionInfo = novelData?.promotionInfo
  const isOnWaitForFreePromotion =
    moment().isAfter(promotionInfo?.waitForFree?.eventStartedAt) &&
    moment().isBefore(promotionInfo?.waitForFree?.eventEndedAt)

  const onClickHandler = async () => {
    UserStore.setBottomsheetOpened(true)
  }

  const StatusTextComponent = () => {
    if (chapterInfo.isFree) return <div className="text-[#FF3E3E]">무료</div>
    if (!chapterInfo.isFree) {
      if (isViewableChapter) {
        return (
          <div className="px-[2vw] flex text-[3vw] text-[#FF3E3E] bg-[#FFEDED] rounded">
            <span className="font-bold mr-1">대여중</span>
            {moment(lastRentedAt).add(novelData?.rentPeriod, 'days').format('M월 D일')}
            까지
          </div>
        )
      }
      return (
        <div className="flex text-[3vw] text-[#BCBDC3]">
          {isViewed ? '대여만료' : ''}
          <div className="text-black ml-1">{chapterInfo?.chapterPrice}코인</div>
        </div>
      )
    }
  }

  return (
    <button
      type="button"
      key={chapterInfo?._id}
      onClick={async () => {
        onClickHandler()
      }}
      className={
        isViewed ? 'flex flex-row mb-4 w-full bg-[#F6F6FA] rounded' : 'flex flex-row mb-4 w-full'
      }
    >
      <div className="relative">
        <div className="flex justify-center items-center w-[24vw] h-[20vw] relative roundedx  border-[#e93838]">
          {/* 블러 처리된 배경 레이어 */}
          <div
            className="absolute top-0 left-0 right-0 bottom-0 w-[24vw] h-[20vw] z-0 rounded"
            style={{
              backgroundImage: `url(${chapterInfo?.detailThumbnail})`,
              backgroundSize: 'cover', // 배경 이미지가 비율 유지하면서 전체를 덮도록 설정
              backgroundPosition: 'center',
              filter: 'blur(4px)', // 배경에만 블러 처리
              opacity: 0.2,
            }}
          />

          {/* 실제 이미지 */}
          <AlwayzImage
            src={resize(chapterInfo?.detailThumbnail, 150, 200, 'fill')}
            alt=""
            className="h-[18vw] rounded-lg "
            lazy
          />
        </div>

        {novelData?.isAdultOnly && (
          <img
            src="/images/toon/isAdultIcon.png"
            alt="ticket"
            className="absolute top-[1vw] right-[1vw] w-[5vw] h-[5vw]"
          />
        )}
        {!chapterInfo.isFree &&
          isOnWaitForFreePromotion &&
          chapterCount - promotionInfo?.waitForFree?.recentChapterLimit >= chapterInfo.episode && (
            <img
              src="/images/toon/waitForFreeIcon.png"
              alt="ticket"
              className="absolute bottom-[1vw] right-[1vw] w-[10vw] h-auto"
            />
          )}
      </div>
      <div className="w-full h-full ml-[4vw] pt-[2vw] text-start text-[4vw]">
        <div className="h-full flex flex-col justify-between">
          <h3 className="font-bold">{chapterInfo?.chapterTitle}</h3>

          <div className="mt-[4vw] flex flex-row text-[2.8vw] justify-start font-semibold">
            <div className="flex flex-row items-center justify-between w-full text-[#9C9DA4]">
              <div className="flex flex-row items-center ">
                <img
                  alt=""
                  style={{
                    marginRight: 2,
                    width: '3vw',
                    height: '3vw',
                  }}
                  src="/images/toon/star.png"
                />
                {Math.round(
                  (chapterInfo?.chapterRatingScore / chapterInfo?.chapterRatingCount) * 100
                ) / 100 || 0}
                <div className="ml-[4vw]">
                  {moment(chapterInfo?.publishedAt).format('YY.MM.DD')}
                </div>
              </div>
              <div className="pr-[2vw]">
                <StatusTextComponent />
              </div>
            </div>
          </div>
        </div>
      </div>
    </button>
  )
}
export default NovelChapterComponent
